import React from 'react';
import { isRoleAdmin, isRoleCustomer, isUserAgent } from 'src/utils/check-user-is-admin';
import Page403 from 'src/pages/403';

export default function AdminAgentOrCusotmerGuard({ children }: { children: React.ReactNode }) {
  return isRoleAdmin() || isUserAgent() || isRoleCustomer() ? <>{children}</> : <Page403 />;
}
